import React from "react";
import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import logo from "../images/logo.svg";
import AvatarDropdown from "./AvatarDropdown";

const NAV_ITEMS = [{ label: "Projects", path: "/projects" }];

const NavLink = ({ to, label }) => {
  const location = useLocation();
  const active =
    location.pathname === to || location.pathname.startsWith(`${to}/`);
  const classes = classNames({
    "px-3 py-2 rounded-md text-sm font-semibold transition": true,
    "text-primary bg-primary bg-opacity-10": active,
    "text-gray-600 hover:text-gray-900 hover:bg-gray-100": !active,
  });
  return (
    <Link to={to} className={classes}>
      {label}
    </Link>
  );
};

const Navbar = () => (
  <nav className="bg-white border-b border-gray-200 sticky top-0 z-10">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
      <div className="flex items-center gap-8">
        <Link to="/projects" className="flex items-center gap-2">
          <img src={logo} alt="Relation" className="h-9 w-9" />
          <span className="text-lg font-bold text-gray-900 tracking-tight">
            Relation
          </span>
        </Link>
        <div className="hidden sm:flex items-center gap-1">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.path} to={item.path} label={item.label} />
          ))}
        </div>
      </div>
      <AvatarDropdown />
    </div>
  </nav>
);

export default Navbar;
